import { formatWordEnding } from "./word";

const formatDateToDDMMYYYY_HHMM = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};

const formatTime = (date: Date) => {
  const d = new Date(date);
  const hours = d.getHours().toString().padStart(2, "0");
  const minutes = d.getMinutes().toString().padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const isToday = (date: Date) => {
  const inputDate = new Date(date);
  const today = new Date();

  const startOfToday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
  );
  const inputDateStart = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate(),
  );

  return inputDateStart.getTime() === startOfToday.getTime();
};

const isYesterday = (date: Date) => {
  const inputDate = new Date(date);
  const today = new Date();

  const startOfYesterday = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate() - 1,
  );

  const inputDateStart = new Date(
    inputDate.getFullYear(),
    inputDate.getMonth(),
    inputDate.getDate(),
  );

  return inputDateStart.getTime() === startOfYesterday.getTime();
};
export const isRecent = (dateString: string) => {
  const now = new Date();
  const date = new Date(dateString);
  const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  return diffInDays < 1;
};
const differenceInHours = (dateLeft: Date, dateRight: Date): number => {
  const msInHour = 1000 * 60 * 60;
  const diffMs = dateLeft.getTime() - dateRight.getTime();
  return Math.floor(diffMs / msInHour);
};

const differenceInMinutes = (dateLeft: Date, dateRight: Date): number => {
  const msInMinute = 1000 * 60;
  const diffMs = dateLeft.getTime() - dateRight.getTime();
  return Math.floor(diffMs / msInMinute);
};

export const formatTodayDate = (payloadDate: string) => {
  const dateNow = new Date();

  if (differenceInHours(dateNow, new Date(payloadDate)) !== 0) {
    const diffInHours = differenceInHours(dateNow, new Date(payloadDate));

    return `${diffInHours} ${formatWordEnding(diffInHours, ["час", "часа", "часов"])} назад`;
  } else if (differenceInMinutes(dateNow, new Date(payloadDate)) !== 0) {
    const diffInMins = differenceInMinutes(dateNow, new Date(payloadDate));

    return `${diffInMins} ${formatWordEnding(diffInMins, ["минуту", "минуты", "минут"])} назад`;
  } else {
    return `Только что`;
  }
};

/** Always-relative label ("N часов/дней/месяцев/лет назад"), unlike `validateDate`
 * which switches to an absolute date past "yesterday". Pair with a tooltip
 * showing `formatDateToDDMMYYYY_HHMM` for the exact timestamp. */
export const formatRelativeAgo = (payload: string) => {
  const now = new Date();
  const date = new Date(payload);
  const diffMs = Math.max(0, now.getTime() - date.getTime());

  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (hours < 1) return "Только что";
  if (hours < 24) {
    return `${hours} ${formatWordEnding(hours, ["час", "часа", "часов"])} назад`;
  }
  if (days < 30) {
    return `${days} ${formatWordEnding(days, ["день", "дня", "дней"])} назад`;
  }
  if (days < 365) {
    const months = Math.floor(days / 30);
    return `${months} ${formatWordEnding(months, ["месяц", "месяца", "месяцев"])} назад`;
  }
  const years = Math.floor(days / 365);
  return `${years} ${formatWordEnding(years, ["год", "года", "лет"])} назад`;
};

export const formatAbsoluteDate = (payload: string) =>
  formatDateToDDMMYYYY_HHMM(new Date(payload));

export const validateDate = (payload: string) => {
  if (isToday(new Date(payload))) {
    return formatTodayDate(payload);
  } else if (isYesterday(new Date(payload))) {
    return `Вчера ${formatTime(new Date(payload))}`;
  }
  return formatDateToDDMMYYYY_HHMM(new Date(payload));
};
